export enum TaskStatus {
  Completed = "Completed",
  NotStarted = "Not Started",
  InProgress = "In Progress",
  OnHold = "On Hold",
  Deferred = "Deferred",
  Escalated = "Escalated",
}
